<template>
    <v-card :class="['kimsa-elevation white-card', {'no-read': lastMessageNotRead}]" @click="showChat">
        <v-row align="center">
            <v-col cols="2" :class="['pa-0 ml-n2 my-n2 img-border', {'secondary': lastMessageNotRead}]">
                <v-img :src="avatar" height="70" class="img-border"/>
            </v-col>
            <v-col cols="10" class="py-1 pr-0">
                <v-row>
                    <v-col cols="12" :class="['name-student text-truncate pb-0', {'white--text': lastMessageNotRead}]">
                        {{ participants }}
                    </v-col>
                    <v-col cols="12" :class="['description-student text-truncate pt-0', {'white--text': lastMessageNotRead}]">
                        <b>{{ lastMessageUsername }}:</b> {{ lastMessage && lastMessage.message || '' }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>

export default {
    props: {
        chat: {
            type: Object,
            required: true
        }
    },
    computed: {
        participants(vm = this) {
            let all = vm.chat.participants.slice()
            let meIndex = all.findIndex(participant => participant.objectID === vm.currentUser.uid)
            if (meIndex !== -1) all.splice(meIndex, 1)
            return all.map(usr => usr.name || usr.email).join(', ')
        },
        client(vm = this) {
            return vm.chat.participants.find(participant => participant.objectID !== vm.currentUser.uid)
        },
        avatar(vm = this) {
            return vm.client?.avatar || vm.imgPlaceholder
        },
        lastMessageUsername(vm = this) {
            return vm.lastMessage?.from?.name || vm.$tc('common.last', 2)
        },
        lastMessage(vm = this) {
            return vm.chat?.lastMessage
        },
        lastMessageNotRead(vm = this) {
            if (vm.lastMessage?.from?.objectID === vm.currentUser.uid) return false
            return vm.lastMessage && !vm.lastMessage.read
        },
    },
    methods: {
        showChat() {
            const vm = this
            vm.$emit('click')
        }
    },
}
</script>

<style scoped>

.name-student {
    color: #333333;
    font-weight: bold;
    font-size: 15px;
}

.description-student {
    color: #707070;
    font-size: 13px;
}

.no-read {
    border: 1px solid var(--v-primary-base);
    background: var(--v-secondary-base);
}

.no-read > .v-row > .v-col > .name-student {
    color: #FFFFFF !important;
}

.img-border {
    border-radius: 4px 0 0 4px;
}

</style>